import { render, staticRenderFns } from "./fortnoxsettings.vue?vue&type=template&id=19a525a2&"
import script from "./fortnoxsettings.vue?vue&type=script&lang=js&"
export * from "./fortnoxsettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports